import React from 'react';
import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';

interface IState {}
interface IProps {}
export default class CloseCompliance extends React.Component<IProps, IState> {
  private headerText: any;
  constructor(props: IProps) {
    super(props);
    this.headerText = [
      { text: 'Work Identification' },
      { text: 'Work Planning' },
      { text: 'Work Scheduling' },
      { text: 'Work Execution and Closeout' },
    ];
  }

  content0() {
    return (
      <div>
        <div className='container-fluid'>
          <iframe
            width='100%'
            height='800px'
            src='https://app.powerbi.com/reportEmbed?reportId=a3648e60-f473-41ed-addb-706ff8f1dbd8&autoAuth=true&ctid=64c46596-1288-4a41-b40f-e629c2a47060'
            frameBorder='0'
            allowFullScreen={true}
          ></iframe>
        </div>
      </div>
    );
  }
  content1() {
    return (
      <div>
        <div className='container-fluid'>
          <iframe
            width='100%'
            height='800px'
            src='https://app.powerbi.com/view?r=eyJrIjoiZjlhZjUwYmUtNGZlMS00MTgzLTlkYzMtYjMwMjgyNWVkOTEyIiwidCI6IjY0YzQ2NTk2LTEyODgtNGE0MS1iNDBmLWU2MjljMmE0NzA2MCJ9&pageName=ReportSection'
            frameBorder='0'
            allowFullScreen={true}
          ></iframe>
        </div>
      </div>
    );
  }
  content2() {
    return (
      <div>
        <div className='container-fluid'>
          <iframe
            width='100%'
            height='800px'
            src='https://app.powerbi.com/view?r=eyJrIjoiY2NkOTAyNDMtMDAwNS00MTYxLTlmMmEtMmM2ZjFjYWQ0ODFhIiwidCI6IjY0YzQ2NTk2LTEyODgtNGE0MS1iNDBmLWU2MjljMmE0NzA2MCJ9&pageName=ReportSection'
            frameBorder='0'
            allowFullScreen={true}
          ></iframe>
        </div>
      </div>
    );
  }

  content3() {
    return (
      <div>
        <div className='container-fluid'>
          <iframe
            width='100%'
            height='800px'
            src='https://app.powerbi.com/reportEmbed?reportId=b285a131-4a83-4de5-b824-686b038f53db&autoAuth=true&ctid=64c46596-1288-4a41-b40f-e629c2a47060'
            allowFullScreen={true}
          ></iframe>
        </div>
      </div>
    );
  }
  content4() {
    return (
      <div>
        <div className='container-fluid'>
          <iframe
            width='100%'
            height='800px'
            src='https://app.powerbi.com/reportEmbed?reportId=b285a131-4a83-4de5-b824-686b038f53db&autoAuth=true&ctid=64c46596-1288-4a41-b40f-e629c2a47060&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWF1c3RyYWxpYS1zb3V0aGVhc3QtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            frameBorder='0'
            allowFullScreen={true}
          ></iframe>
        </div>
      </div>
    );
  }
  content5() {
    return (
      <div>
        <div className='container-fluid'>
          <iframe
            width='100%'
            height='800px'
            src='https://app.powerbi.com/reportEmbed?reportId=db361192-8863-49a9-93b0-56083ecfcac5&autoAuth=true&ctid=64c46596-1288-4a41-b40f-e629c2a47060&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWF1c3RyYWxpYS1zb3V0aGVhc3QtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            frameBorder='0'
            allowFullScreen={true}
          ></iframe>
        </div>
      </div>
    );
  }
  content6() {
    return (
      <div>
        <div className='container-fluid'>
          <iframe
            width='100%'
            height='800px'
            src='https://app.powerbi.com/reportEmbed?reportId=f1e32b1c-321f-4f1c-a540-29ffe9c120bb&autoAuth=true&ctid=64c46596-1288-4a41-b40f-e629c2a47060&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWF1c3RyYWxpYS1zb3V0aGVhc3QtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D'
            frameBorder='0'
            allowFullScreen={true}
          ></iframe>
        </div>
      </div>
    );
  }
  content7() {
    return (
      <div>
        <div className='container-fluid'>
          <iframe
            title='Preventative Maintenance Strategies'
            width='100%'
            height='800px'
            src='https://app.powerbi.com/reportEmbed?reportId=f1e32b1c-321f-4f1c-a540-29ffe9c120bb&autoAuth=true&ctid=64c46596-1288-4a41-b40f-e629c2a47060'
            allowFullScreen={true}
          ></iframe>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='container-fluid'>
        <TabComponent  statelessTemplates={['directiveTemplates']}>
          <TabItemsDirective>
            <TabItemDirective
              header={this.headerText[0]}
              content={this.content0}
            />
            <TabItemDirective
              header={this.headerText[1]}
              content={this.content1}
            />
            <TabItemDirective
              header={this.headerText[2]}
              content={this.content2}
            />
            <TabItemDirective
              header={this.headerText[3]}
              content={this.content3}
            />
            <TabItemDirective
              header={{ text: 'Maintenance Work Orders' }}
              content={this.content3}
            />
            <TabItemDirective
              header={{ text: 'Maintenance Monitoring Points' }}
              content={this.content5}
            />
            <TabItemDirective
              header={{ text: 'Maintenance Strategies' }}
              content={this.content3}
            />
            <TabItemDirective
              header={{ text: 'Maintenance Forecast' }}
              content={this.content7}
            />
          </TabItemsDirective>
        </TabComponent>
      </div>
    );
  }
}
